/**
 * @author 3173
 * @description 远程认证详情页面配置
 * @Date 2020/8/15
 */
import React from 'react'
import { component_tool, framework_tool,utils_tool } from '@/tool';
import { WizTableForm } from '../../../common'
import moment from "moment";
//import AuthVideo from './authVideo';
import SetAuthDate from './setAuthDate';
import AuthVideo from './../../class/classStudent/classStudentRemoteAuth/authVideo';
import BatchInput from "./../../class/classStudent/classStudentRemoteAuth/batchInput";
import { WizNotice } from 'wiz-components';
let { $$, checkStrLength } = utils_tool;
const personInfoConfig = WizTableForm.Config.user(this, { apiParams: { state: 1,positionIdList: ["110"] },path:'personManage/getTeachelist' })
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1,roleConfig: "teacherRole" } });
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

let { WizModal, WizTimePicker } = component_tool;
const { RangePicker } = WizTimePicker;
let ref_;



//配置项
let componentName = 'studentRemoteAuthDetail'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: '认证日期',
    name: 'openTime',
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  },
  {
    title: "认证场次",
    name: "name",
    searchItem: {
    },
  },
  {
    title: "认证名称",
    name: "remoteAuthName",
    searchItem: {
    },
  },
  {
    title: "学员姓名",
    name: "fullName",
    searchItem: {},
    tableItem: {
      width: 80,
      // render(value, row, index) {
      //   const obj = {
      //     children: value,
      //     props: {},
      //   };
      //   if (index ==0){
      //     obj.props.rowSpan = 2;
      //   }
      //   return obj;
      // }
    },
  },

  {
    title: "学员账号",
    name: "userName",
    searchItem: {},
    tableItem: {
      width: 80
    },
  },
  
  {
    title: "认证日期",
    name: "authDateStr",
    tableItem: {
      width: 120,
      render: (text, record) => {
        return formatterDate(text)
      }
    },
  },
  {
    title: "认证时间",
    name: "startToEndDateStr",
    tableItem: {
      width: 200,
    },
  },
  {
    title: "认证状态",
    name: "authState",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '未开始' },
      { code: 2, codeName: '认证中' },
      { code: 3, codeName: '未参考' },
      { code: 4, codeName: '已完成' },
      { code: 6, codeName: '已作废' }
    ],
    tableItem: {
      width: 80,
    },
  },
  {
    title: "讲师",
    name: "lectureName",
    tableItem: {
      width: 80,
    },
  },
  {
    title: "总得分",
    name: "score",
    tableItem: {
      width: 60,
      render: (text, record) => {
        return text && text < 0 ? '' : text
      }
    },
  },
  {
    title: "通过状态",
    name: "pass",
    dict: [
      { code: 0, codeName: '未通过' },
      { code: 1, codeName: '通过' }
    ],
    tableItem: {
      width: 80,
    },
  },
  {
    title: "发布状态",
    name: "publishState",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '待更新' },
      { code: 1, codeName: '可发布' },
      { code: 2, codeName: '已发布' },
      { code: 3, codeName: '未参考' }
    ],
    tableItem: {
      width: 80,
    },
  },
  {
    title: "讲师",
    name: "lectureIds",
    searchItem: {
      type: 'diy',
      diy: WizTableForm,
      cols: { xs: 16, md: 14, xl: 12 },
      ...userConfig,
      onSubmit:(obj)=>{
        return obj.value
      }
    },
  },
  {
    title: "通过状态",
    name: "pass",
    dict: [
      { code: 0, codeName: '未通过' },
      { code: 1, codeName: '通过' }
    ],
    searchItem: {
      type: 'select'
    }, 
    // tableItem: {
    // },
  },
  {
    title: "经销商简称",
    name: "dealerName",
    searchItem: {},
    tableItem: { width: 100 },
  },
  {
    title: "经销商代码",
    name: "dealerCode",
    searchItem: {},
    tableItem: {},
  },
  {
    title: "认证场次",
    name: "name",
    tableItem: {
      width: 150
    },
  },
  {
    title: "认证名称",
    name: "remoteAuthName",
    tableItem: {
      width: 150
    },
  },
];


const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      //btnAccessCheck: false,
      searchBarProps: {
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['openTime'] && value['openTime'].length === 2) {
            value['authStartDate'] = moment(value['openTime'][0]).format("YYYY-MM-DD");
            value['authEndDate'] = moment(value['openTime'][1]).format("YYYY-MM-DD");
          }else{
            value['authStartDate'] = undefined;
            value['authEndDate'] = undefined;
          }
          // delete value['openTime']
          return value
        },
        buttonSort: ['resultsGrades','importGrades','export'],
        buttons: [
          {
            key: 'importGrades',
            custom: true,
            params: { icon: 'import', children: '导入成绩', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/remoteAuthList/studentRemoteAuthDetailList/studentRemoteAuthScoreImport'
              }
            }
          },
          {
            key: 'resultsGrades',
            custom: true,
            needSelect: true,
            params: { children: '发布成绩'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'publishState',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                const content = `您确定要发布这${
                  $$.isArray(rows) ? rows.length : ""
                  }条成绩？`;
                let ids = [];
                let flag = false;
                rows.forEach(e => {
                  if (e['rowKey']) {
                    ids.push(e['rowKey']);
                  }
                  if (e['publishState']!=1){
                    flag = true;
                  }
                });
                if(flag){
                  wizNotice.warn("只可选择可发布状态的学员进行发布成绩,请确认后重试!") 
                  return;
                }
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      idList: ids,
                      publishState: 2
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {  icon: 'export', children: '导出'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['authenticationSet','videoPlayback', 'modifyScore','download'],
      rowOperateView: [
        // {
        //   key: "set",
        //   custom: true,
        //   params: { children: "认证设置" },
        //   customOnClick: {
        //     key: "modal",
        //     params: {
        //       modalKey: "setAuthModal",
        //       modalParams: {
        //         title: "认证设置",
        //         diy: (e) => {
        //           e.record = Object.assign({}, e.record);
        //           const formProps = {
        //             ref: 'form',
        //             record: e.record,
        //             preview: false,
        //             footer: false,
        //             formItemLayout: {
        //               labelCol: { span: 4 },
        //               wrapperCol: { span: 17 }
        //             },
        //           };
        //           return (
        //             <SetAuthDate {...formProps}
        //               key={'setAuth-'+e.record.id+'-'+e.record.remoteAuthId+'-'+e.record.personId}
        //               {...e}
        //               ref={r => {
        //                 ref_ = r && r.getWrappedInstance();
        //               }}
        //             />
        //           )
        //         },
        //         // onOk: () => {
        //         //   ref_._update()
        //         // },
        //         onCancel: () => {
        //           ref_._reset()
        //         },
        //         footer:null,
        //         width: 700
        //       }
        //     },
        //     formatParams: (rows, record, filter) => {
        //       return { ...record };
        //     }
        //   },
        //   recordChangeParams: (record, rows) => {
        //     let result = { disabled: true };
        //     if (record.record && record.record.publishState === 0 && record.record.authState === 0) {
        //       result.disabled = false
        //     }
        //     return result
        //   },
        // },
        {
          key: "authenticationSet",
          custom: true,
          params: {children: '认证设置'},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: new Date().getTime(),
              modalParams: {
                title: "认证设置",
                diy: (e) => {
                  e.record = Object.assign({}, e.record)
                  let initRows = () => {
                    return [e.record]
                  };
                  let classAideEntityInfo = {};
                  classAideEntityInfo.classDate = [];
                  classAideEntityInfo.classDate.push(e.record.classAideStartDate);
                  classAideEntityInfo.classDate.push(e.record.classAideEndDate);
                  return (
                    <BatchInput
                      {...e}
                      key={'BatchInput' + e.record.id + new Date().getTime()}
                      initRows={initRows}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                      timeStamp={new Date().getTime()}
                      classInfoId={e.record.classInfoId}
                      classAideId={e.record.classAideId}
                      entityId={e.record.remoteAuthId}
                      classAideEntityInfo={classAideEntityInfo}
                      alone={true}
                    />
                  )
                },
                onOk: () => {
                  ref_._ok();
                },
                onCancel: () => {
                  ref_._doInitParams()
                },
                width: 600
              }
            },
            formatParams: (rows, record, filter) => {
              return {...record};
            },
          },
          recordChangeParams: (record, rows) => {
            let result = {disabled: true};
            if (record.record && record.record.publishState === 0 && record.record.authState === 0) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "videoPlayback",
          custom: true,
          params: { children: "录像回放"},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "playbackModal",
              modalParams: {
                title: "录像回放",
                diy: (e) => {
                  e.record = Object.assign({}, e.record);
                  return (
                    <AuthVideo
                      key={'authVideo-'+e.record.id}
                      {...e}
                      type={0}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                footer:null,

                width: 700
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.publishState > 0 && record.record.publishState!=3) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "modifyScore",
          custom: true,
          params: { children: "修改分数" },
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/remoteAuth/studentRemoteAuthDetailList/studentRemoteAuthScore'
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.publishState === 1) {
              result.disabled = false
            }
            return result
          },
        },

        {
          key: "download",
          custom: true,
          params: { children: "视频下载"},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "downloadModal",
              modalParams: {
                title: "视频下载",
                diy: (e) => {
                  e.record = Object.assign({}, e.record);
                  return (
                    <AuthVideo
                      key={'authVideo-'+e.record.id}
                      {...e}
                      type={1}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                footer:null,

                width: 700
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.publishState > 0 && record.record.publishState!=3) {
              result.disabled = false
            }
            return result
          },
        }
      ]
    }
  }
};

let reduxTemplateCofig = (args) => {
  let {remoteAuthId }= args;
  const apis = {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {remoteAuthId : remoteAuthId ? remoteAuthId : null , type:1}
      }
    },
    publishState: {
      path: `${componentName}/publishStateRe`,
      payload: {
        key: `${componentName}@publishState`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {remoteAuthId : remoteAuthId ? remoteAuthId : null , type:1}
      }
    }
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
